<ng-template #windowPortal>
  <section
    class="settings-window"
    role="dialog"
    aria-modal="true"
    aria-labelledby="settings-window-page-title"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (keydown.escape)="close()"
  >
    <nav class="settings-window-rail" aria-label="Settings">
      <div class="settings-window-rail-heading">
        <h1>Settings</h1>
        <p>{{ railSubtitle() }}</p>
      </div>

      <div class="settings-window-menu">
        @for (group of menu(); track group.label) {
          <section class="settings-window-menu-group">
            <button
              type="button"
              class="settings-window-group-heading"
              [attr.aria-expanded]="groupOpen(group.label)"
              (click)="toggleGroup(group.label)"
            >
              <app-icon
                name="sapphire-chevron-right"
                [size]="16"
                [class.settings-window-chevron-open]="groupOpen(group.label)"
              />
              <span>{{ group.label }}</span>
            </button>
            @if (groupOpen(group.label)) {
              @for (row of group.rows; track row.path) {
                <div class="settings-window-row-wrap" [class.settings-window-app-wrap]="row.kind === 'app'">
                  @if (row.kind === 'app' && row.children?.length) {
                    <button
                      type="button"
                      class="settings-window-app-toggle"
                      [attr.aria-label]="(appOpen(row.path) ? 'Collapse ' : 'Expand ') + row.label"
                      [attr.aria-expanded]="appOpen(row.path)"
                      (click)="toggleApp(row.path)"
                    >
                      <app-icon
                        name="sapphire-chevron-right"
                        [size]="16"
                        [class.settings-window-chevron-open]="appOpen(row.path)"
                      />
                    </button>
                  }
                  <a
                    class="settings-window-menu-row"
                    [class.settings-window-app-row]="row.kind === 'app'"
                    [routerLink]="row.path"
                    [class.settings-window-menu-row-selected]="isCurrent(row.path)"
                    [attr.aria-current]="isCurrent(row.path) ? 'page' : null"
                  >
                    @if (row.icon) {
                      <app-icon [name]="$any(row.icon)" [size]="20" />
                    }
                    <span>{{ row.label }}</span>
                  </a>
                  @if (row.kind === 'app' && appOpen(row.path)) {
                    @for (child of row.children ?? []; track child.id) {
                      <a
                        class="settings-window-menu-row settings-window-subpage-row"
                        [routerLink]="child.path"
                        [class.settings-window-menu-row-selected]="isCurrent(child.path)"
                        [attr.aria-current]="isCurrent(child.path) ? 'page' : null"
                      >
                        {{ child.label }}
                      </a>
                    }
                  }
                </div>
              }
            }
          </section>
        }
      </div>
    </nav>

    <main class="settings-window-page">
      <app-settings-page-header
        [heading]="heading()"
        [subtitle]="pageSubtitle()"
        [backLabel]="backLabel()"
        [actionLabel]="headerAction()?.label ?? ''"
        [actionDisabled]="headerAction()?.disabled ?? false"
        titleId="settings-window-page-title"
        (actionPressed)="headerAction()?.activate()"
        (goBack)="backToSection()"
        (closeWindow)="close()"
      />
      <router-outlet (activate)="onPageActivated($event)" (deactivate)="onPageDeactivated()" />
    </main>
  </section>
</ng-template>
